import { colorHex } from "../../../styles";

import { Logo } from "./Logo";

export const WhiteLogo = ({
    actualHeight,
    actualWidth,
    intrinsicHeight,
    intrinsicWidth,
    id
}: {
    actualHeight?: number;
    actualWidth?: number;
    intrinsicWidth: number;
    intrinsicHeight: number;
    id: string;
}) => {
    const white = colorHex("N0");
    return (
        <Logo
            as="svg"
            aria-label="Trello"
            fill={white}
            height={actualHeight}
            role="img"
            viewBox={[0, 0, intrinsicWidth, intrinsicHeight].join(" ")}
            width={actualWidth}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <linearGradient
                id={`trello-logo-gradient-white${id}`}
                x1="49.999978%"
                x2="49.999978%"
                y1="99.983977%"
                y2=".032046%"
            >
                <stop offset="0" stopColor={white} stopOpacity=".5" />
                <stop offset=".15" stopColor={white} stopOpacity=".65" />
                <stop offset=".3" stopColor={white} stopOpacity=".78" />
                <stop offset=".46" stopColor={white} stopOpacity=".88" />
                <stop offset=".62" stopColor={white} stopOpacity=".95" />
                <stop offset=".8" stopColor={white} stopOpacity=".99" />
                <stop offset="1" stopColor={white} />
            </linearGradient>
            <path
                d="m55.75 0h-47.56c-4.09243 0-7.41 3.31757-7.41 7.41v47.59c0 4.09243 3.31757 7.41 7.41 7.41h47.56c4.09243 0 7.410027-3.31757 7.410027-7.41v-47.57c.0052867-1.96871715-.7730611-3.85862176-2.163282-5.25259496s-3.2780207-2.17740504-5.246745-2.17740504zm-28.1 45c0 1.3602476-1.0997635 2.4644929-2.46 2.47h-10.43c-1.3618668-.0054804-2.4645196-1.1081332-2.47-2.47v-31c.0054804-1.3618668 1.1081332-2.4645196 2.47-2.47h10.43c1.3602365.0055071 2.46 1.1097524 2.46 2.47zm24-14.21c-.0054804 1.3618668-1.1081332 2.4645196-2.47 2.47h-10.43c-1.3602365-.0055071-2.46-1.1097524-2.46-2.47v-16.79c0-1.3602476 1.0997635-2.4644929 2.46-2.47h10.43c1.3618668.0054804 2.4645196 1.1081332 2.47 2.47z"
                fill={`url(#trello-logo-gradient-white${id})`}
            />
            <path d="m130.08 4.59v12.06h-14.3v45.75h-13.78v-45.75h-14.28v-12.06z" />
            <path d="m147.62 62.4h-12.74v-45h12.74v8.62c2.41-6.07 6.28-9.67 13.17-9.23v13.32c-8.95-.7-13.17 1.5-13.17 8.71z" />
            <path d="m230.4 62.76c-8.35 0-13.61-4.05-13.61-13.47v-49.29h12.83v47.53c0 2.73 1.81 3.7 4 3.7.631315.0130885 1.262786-.0169816 1.89-.09v11.09c-1.670462.4130783-3.39032.5914589-5.11.53z" />
            <path d="m257.17 62.76c-8.35 0-13.6-4.05-13.6-13.47v-49.29h12.83v47.53c0 2.73 1.81 3.7 4 3.7.634638.0128631 1.269419-.0172055 1.9-.09v11.09c-1.677002.4145441-3.403668.5929326-5.13.53z" />
            <path d="m268.47 39.88c0-13.9 8-23.41 21.78-23.41s21.61 9.53 21.61 23.41-7.92 23.58-21.61 23.58-21.78-9.77-21.78-23.58zm12.48 0c0 6.78 2.84 12.14 9.3 12.14s9.13-5.36 9.13-12.14-2.76-12-9.13-12-9.25 5.22-9.25 12z" />
            <path d="m178 44c3.570328.3922021 7.1583.602474 10.75.63 9.75 0 18-2.62 18-12.06 0-9.17-8.47-16.07-18.66-16.07-13.72 0-22.5 10-22.5 23.85 0 14.43 7.58 23 24.71 23 5.085091.0521078 10.135127-.8466563 14.89-2.65v-10.83c-4.39 1.4-9.35 2.8-14.43 2.8-6.86 0-11.58-2.24-12.76-8.67zm9.83-17.68c3.61 0 6.51 2.45 6.51 5.8 0 4.32-4.56 5.66-9.79 5.66-2.230114-.0102442-4.456334-.1874058-6.66-.53.163357-2.1005717.762772-4.1440305 1.76-6 1.624894-3.0101722 4.749674-4.9072236 8.17-4.96z" />
        </Logo>
    );
};
